import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface ScrollToContentButtonProps {
  isAnimated: boolean;
  onClick: () => void;
  /** Accessible name for the scroll cue. */
  ariaLabel?: string;
  className?: string;
}

/**
 * Bouncing chevron control — used on chapter intro to scroll into the content band.
 */
const ScrollToContentButton = ({
  isAnimated,
  onClick,
  ariaLabel = "Zum Inhalt scrollen",
  className,
}: ScrollToContentButtonProps) => (
  <div className={cn("flex flex-col items-center", className)}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={onClick}
          aria-label={ariaLabel}
          className="relative size-[3.75em] text-h4 text-primary hover:translate-y-0 hover:bg-primary/10 hover:text-primary"
        >
          <span className="relative flex flex-col items-center justify-center gap-[0.15em]">
            <ChevronDown
              className={cn("size-[2em]", isAnimated && "animate-bounce")}
            />
            <span
              aria-hidden="true"
              className={cn(
                "h-[0.22em] w-[1.35em] rounded-full bg-current",
                isAnimated &&
                  "motion-safe:animate-[chevron-shadow_1s_ease-in-out_infinite]"
              )}
            />
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">Weiter</TooltipContent>
    </Tooltip>
  </div>
);

export default ScrollToContentButton;
